/* eslint-disable */
import {
  useEffect, useRef, useState, useContext,
} from 'react';
import { getVpsId } from '@/apis/offer';

import ikea from 'ikea-jssdk';
import { isLogin, goLogin } from '@/adaptPlatform/index';
import { AppContext } from '@/redux/store';
import ArcLoading from '@/components/Loading/loading';

export function isProdMode() {
  const prodMode = window.location.host === 'besta-online-web.aidesign.ingka-internal.cn';
  return prodMode;
}

export function getCookie(name) {
  const nameEQ = `${name}=`;
  const ca = document.cookie.split(';');
  // eslint-disable-next-line no-plusplus
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}

export const compareVersion = (version1, version2) => {
  const arr1 = version1.split('.');
  const arr2 = version2.split('.');

  const len = Math.max(arr1.length, arr2.length);
  // eslint-disable-next-line no-plusplus
  for (let i = 0; i < len; i++) {
    let data1 = 0; let
      data2 = 0;
    if (i < arr1.length) {
      data1 = parseInt(arr1[i], 10);
    }
    if (i < arr2.length) {
      data2 = parseInt(arr2[i], 10);
    }

    if (data1 < data2) {
      return -1;
    } if (data1 > data2) {
      return 1;
    }
  }
  return 0;
};


export const supportSaveDesign = async () => {
  const { value } = await ikea.currentPlatform();
  if (value && (value.platform === 'iOS' || value.platform === 'ANDROID')) {
    const supportVersion = isProdMode() ? '3.11.0' : '3.10.0';
    return compareVersion(getCookie('app_version') || '0', supportVersion) >= 0;
  }

  return true;
};

export default function useDetail() {
  const [isShowToast, setIsShowToast] = useState(false);
  const [isSavedDesign, setIsSavedDesign] = useState(false);
  const timer1 = useRef();
  const oldParams = useRef();
  const oldVpsId = useRef();
  const { storeState } = useContext(AppContext);

  useEffect(() => () => {
    if (timer1.current) window.clearTimeout(timer1.current);
  }, []);

  // 获取vpsId
  const getVpsIdFn = async (params) => {
    const c = oldParams.current;
    console.log('oldParams.current', oldParams.current);
    const result = await getVpsId(params);
    const vpsId = result?.data?.data?.vpsId;
    console.log('result?.data?.data?.vpsId', vpsId);
    oldVpsId.current = vpsId;
    return vpsId;
  };
  const saveResult = (res, showToast) => {
    ArcLoading.hide();
    clearTimeout(timer1.current);
    setIsSavedDesign(res);
    setIsShowToast(!!showToast);
    timer1.current = setTimeout(() => {
      setIsShowToast(false);
    }, 4000);
    console.log('addMyDesign---success', res);
  };

  /**
   * 保存在我的设计方案中
   * @param {*} showToast 是否显示保存结果的提示
   * @param {*} templateId
   * @returns
   */
  const saveMyDesign = async (showToast, params) => {
    try {
      console.log('saveMyDesign', params);
      const vpsId = await getVpsIdFn(params);
      console.log('vpsId', vpsId);
      const addRes = await ikea.request({
        path: `/content/interacts/create/LIKE/VTP/${vpsId}?targetSubType=KITCHEN`,
        method: 'post',
      });
      console.log('addRes', addRes);
      if (addRes) {
        localStorage.setItem('lastSaveParams', JSON.stringify(params));
        saveResult(true, showToast);
      } else {
        saveResult(false, showToast);
      }
      return addRes;
    } catch (e) {
      console.log('error', e);
      saveResult(false, showToast);
      return '';
    }
  };
  /**
   * 先check是否登录，再save方案
   * @param {boolean} showToast 是否显示保存结果的提示
   * @param {string} templateId
   * @param {boolean} needLogin 如果没有登录则不需要保存我的方案
   *  @param {boolean} checkCache 是否判断本地缓存中上一次save的templateId or designCode，不需要的话则每次都save
   * @returns
   */
  const addMyDesign = async (
    showToast,
    params = { templateId: '', designCode: '' },
    checkCache = true,
  ) => {
    const surport = await supportSaveDesign();
    if (!surport) return;
    // ArcLoading.show();
    // 需要check本地缓存上次save成功的柜子，和上次一样则不再save
    const lastSaveParamsStr = localStorage.getItem('lastSaveParams');
    if (checkCache && lastSaveParamsStr) {
      console.log('lastSaveParamsStr', lastSaveParamsStr, params);
      const lastSaveParams = JSON.parse(lastSaveParamsStr);
      if ((lastSaveParams.templateId && lastSaveParams.templateId === params.templateId)
        || (lastSaveParams.designCode && lastSaveParams.designCode === params.designCode)) {
        return;
      }
    }
    // 如果没有登录则不需要保存我的方案
    const { value } = await isLogin();
    console.log("tgr v", value)
    if (!value) return;
    await saveMyDesign(showToast, params)
  };

  return {
    isShowToast,
    setIsShowToast,
    isSavedDesign,
    addMyDesign,
    getVpsIdFn,
  };
}
